
import React from 'react';
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { LanguageCode, languageInfo } from '@/utils/languageUtils';

interface LanguageMenuItemProps {
  code: LanguageCode;
  isActive: boolean;
  onSelect: (code: LanguageCode) => void;
}

const LanguageMenuItem: React.FC<LanguageMenuItemProps> = ({ 
  code, 
  isActive, 
  onSelect 
}) => {
  const { flag, name } = languageInfo[code];
  
  return (
    <DropdownMenuItem 
      onClick={() => onSelect(code)}
      className={`
        flex items-center gap-3 px-3 py-2.5 rounded-sm cursor-pointer transition-all duration-200
        ${isActive 
          ? 'bg-purple-900/40 text-purple-300 font-semibold shadow-sm shadow-purple-500/20' 
          : 'text-gray-200 hover:bg-purple-900/20 hover:text-purple-300'
        }
      `}
    >
      <span className="text-xl font-emoji">{flag}</span>
      <span className="text-sm">{name}</span>
    </DropdownMenuItem>
  );
};

export default LanguageMenuItem;
